module.exports = __webpack_public_path__ + "static/media/BizinCLOUD Logo Main.85204599.png";